import src from "IMAGE";
export default { src, width: 125, height: 48, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAPklEQVR42n3FMQoAEBSA4VcyyQWoRwbZZcIoF+Hd/wgMMslfXz/AJ86EBKsiOp3si8caoJeJvZLZP+hqeeACdOYM+PTk4GEAAAAASUVORK5CYII="};
